import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    INVENTORY_CHANGE_REASON_TAGS_QUERY,
    SINGLE_INVENTORY_CHANGE_REASON_TAG_QUERY,
    CREATE_INVENTORY_CHANGE_REASON_TAG_MUTATION,
    UPDATE_INVENTORY_CHANGE_REASON_TAG_MUTATION,
    DELETE_INVENTORY_CHANGE_REASON_TAG_MUTATION
} from "@/graphql/inventoryChangeReasonTags.js";

const state = {
    inventoryChangeReasonTags: []
};

const getters = {};

const mutations = {
    [types.SET_INVENTORY_CHANGE_REASON_TAGS](state, inventoryChangeReasonTags) {
        state.inventoryChangeReasonTags = inventoryChangeReasonTags;
    },
    [types.SORT_INVENTORY_CHANGE_REASON_TAGS](state) {
        state.inventoryChangeReasonTags.sort(function(a, b) {
            return a.node.tag ==
                b.node.tag
                ? 0
                : a.node.tag >
                  b.node.tag
                ? 1
                : -1;
        });
    },
    [types.UPSERT_INVENTORY_CHANGE_REASON_TAG](state, inventoryChangeReasonTag) {
        var index = state.inventoryChangeReasonTags.findIndex(function(element) {
            return element.node.id == inventoryChangeReasonTag.id;
        });

        const node = { node: inventoryChangeReasonTag };

        if (index > -1) {
            state.inventoryChangeReasonTags.splice(index, 1, node);
        } else {
            state.inventoryChangeReasonTags.unshift(node);
        }
    },
    [types.DELETE_INVENTORY_CHANGE_REASON_TAG](state, inventoryChangeReasonTag) {
        var index = state.inventoryChangeReasonTags.find(function(element, index) {
            if (element.id == inventoryChangeReasonTag.id) {
                return index;
            }
        });

        if (index > -1) {
            state.inventoryChangeReasonTags.splice(index, 1);
        }
    }
};

const actions = {
    async fetchInventoryChangeReasonTags(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: INVENTORY_CHANGE_REASON_TAGS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const inventoryChangeReasonTags = response.data.tenantTags.edges;

                    // update store
                    context.commit(types.SET_TAGS, inventoryChangeReasonTags);

                    // sort
                    context.commit(types.SORT_TAGS);

                    resolve(inventoryChangeReasonTags);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleInventoryChangeReasonTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_INVENTORY_CHANGE_REASON_TAG_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const inventoryChangeReasonTag = response.data.inventoryChangeReasonTag;

                    // update store
                    context.commit(types.UPSERT_INVENTORY_CHANGE_REASON_TAG, inventoryChangeReasonTag);

                    // sort
                    context.commit(types.SORT_INVENTORY_CHANGE_REASON_TAGS);

                    resolve(inventoryChangeReasonTag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createInventoryChangeReasonTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_INVENTORY_CHANGE_REASON_TAG_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const inventoryChangeReasonTag = response.data.createInventoryChangeReasonTag.inventoryChangeReasonTag;

                    // update store
                    context.commit(types.UPSERT_INVENTORY_CHANGE_REASON_TAG, inventoryChangeReasonTag);

                    // sort
                    context.commit(types.SORT_INVENTORY_CHANGE_REASON_TAGS);

                    resolve(inventoryChangeReasonTag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateInventoryChangeReasonTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_INVENTORY_CHANGE_REASON_TAG_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const inventoryChangeReasonTag = response.data.updateInventoryChangeReasonTag.inventoryChangeReasonTag;

                    // update store
                    context.commit(types.UPSERT_INVENTORY_CHANGE_REASON_TAG, inventoryChangeReasonTag);

                    // sort
                    context.commit(types.SORT_INVENTORY_CHANGE_REASON_TAGS);

                    resolve(inventoryChangeReasonTag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteInventoryChangeReasonTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_INVENTORY_CHANGE_REASON_TAG_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const inventoryChangeReasonTag = response.data.deleteInventoryChangeReasonTag.inventoryChangeReasonTag;

                    // update store
                    context.commit(types.DELETE_INVENTORY_CHANGE_REASON_TAG, inventoryChangeReasonTag);

                    resolve(inventoryChangeReasonTag);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
